<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />
        <tabsComp :tabs="tabs" />
        <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:-35px !important;`">
            <v-row style="margin-top:45px;">
                <v-col cols="12" md="12">
                    <form autocomplete="off">
                        <div class="searchTop" style="margin-inline-end:-20px !important;">
                            <div class="searchBar">
                                <div>
                                    <div>{{ lang.chose_from_list }} {{ lang.start_date }}</div>
                                    <b-input-group>
                                        <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="sd.day" :options="daysList" />
                                        <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="sd.month" :options="monthsList" />
                                        <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="sd.year" :options="yearsList" />
                                    </b-input-group>
                                </div>
                                <div>
                                    <div>{{ lang.chose_from_list }} {{ lang.end_date }}</div>
                                    <b-input-group>
                                        <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="ed.day" :options="daysList" />
                                        <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="ed.month" :options="monthsList" />
                                        <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="ed.year" :options="yearsList" />
                                    </b-input-group>
                                </div>
                                <div>
                                    <div>{{ lang.po_number }}</div>
                                    <b-form-input class="inborder" v-model="po_number" style="background:#efefef;" />
                                </div>
                                <div v-if="$store.state.licenseType.showCheckBranch">
                                    <div>{{ lang.branch_name }}</div>
                                    <b-form-select class="inborder" v-model="branch" :options="branchesList" />
                                </div>
                                <div>
                                    <div>{{ lang.checkup_number }}</div>
                                    <b-form-input class="inborder" v-model="checkup_number" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>{{ lang.mobile }}</div>
                                    <b-form-input class="inborder" v-model="mobile" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>{{ lang.device_name }}</div>
                                    <b-form-input class="inborder" v-model="device_name" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>{{ lang.serial_number }}</div>
                                    <b-form-input class="inborder" v-model="serial_number" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>{{ lang.status }}</div>
                                    <b-input-group>
                                        <b-form-select class="selborder" v-model="status" :options="checkStatuss" />
                                        <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                                            <i class="fas fa-arrow-down"></i>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                                <div>
                                    <div>&nbsp;</div>
                                    <b-button variant="light" style="padding-top:2px !important; padding-bottom:2px !important;background:blue;color:#fff;width:75px;" @click="getCheckup()">{{ lang.search }}</b-button>
                                </div>
                            </div>
                            <div style="margin-inline-end:17px;">
                                <b-button
                                    @click="addCheck()"
                                    v-b-toggle.add_device_check
                                    class="btn-sm btn"
                                    style="margin-top:7px;width:170px;background:transparent;border:none !important;margin-left:-7px !important;"
                                    id="multiply-button"
                                >
                                    <div :class="`multiply-button-content-`+lang.lalgin" style="width:170px;border:none !important">{{ text('add_device_check') }}</div>
                                </b-button>
                            </div>
                        </div>
                    </form>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="md-3" :style="`direction:`+lang.dir+`;`">
                    <v-data-table
                        :headers="headers"
                        :items="tablerows"
                        :search="search"
                        :items-per-page="-1"
                        width="100%"
                        id="MainTable"
                        hide-default-footer
                        fixed-header
                    >
                        <template slot="body.prepend">
                            <tr>
                                <td style="font-size:.1rem !important;background:#fff !important;border-inline:none !important;border-top:1px solid #000 !important;" :colspan="headers.length">&#32;</td>
                            </tr>
                        </template>
                        <template v-slot:item="row">
                            <tr>
                                <td style="width:50px;text-align:center;">{{ row.item.count }}</td>
                                <td style="width:50px;text-align:center;">{{ row.item.id }}</td>
                                <td style="width:50px;text-align:center;">{{ row.item.created_date_ }}</td>
                                <td class="text-center" nowrap style="text-align:center;" v-if="$store.state.licenseType.showCheckBranch">{{ row.item.branch }}</td>
                                <td class="text-center" nowrap style="text-align:center;">{{ row.item.customer_name }}</td>
                                <td class="text-center" nowrap style="text-align:center;">{{ row.item.owner_name }}</td>
                                <td class="text-center" nowrap style="text-align:center;">{{ row.item.mobile }}</td>
                                <td class="text-center" nowrap style="text-align:center;">{{ row.item.owner_mobile_number }}</td>
                                <td class="device-cell">{{ deviceDisplay(row.item) }}</td>
                                <td class="text-center">{{ deviceSerial(row.item) }}</td>
                                <td :style="`width:80px;text-align:center;`">{{ row.item.po_number }}</td>
                                <td :style="`width:80px;text-align:center;`">{{ row.item.status }}</td>
                                <td
                                    style="cursor:pointer;width:85px;border-top:1px solid #bbb !important;border-bottom:1px solid #bbb !important;"
                                    class="backBlue text-center"
                                    v-b-toggle.add_device_check
                                >
                                    <div style="color:#fff !important;" @click="viewCheckup(row.item)">{{ lang.view }}</div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-row>
        <addDeviceCheckup ref="addCheckup" />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import ExportsPrint from '@/components/exports-print.vue'
import TabsComp from '@/components/tabsComp.vue'
import addDeviceCheckup from '@/components/addDeviceCheckup.vue'
import axios from 'axios'
import { getVisibleTabsForRoute } from '@/menu/menuService'

export default {
    components: {
        HeaderPortrate, ExportsPrint, TabsComp, addDeviceCheckup
    },
    data() {
        return {
            branches: [],
            mobile: '',
            status: '',
            search: '',
            branch: '',
            po_number: '',
            checkup_number: '',
            device_name: '',
            serial_number: '',
            tablerows: [],
            sd: {
                day: 1,
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            ed: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            },
            checkUpStatus: []
        }
    },
    computed: {
        lang: function() {
            if(this.$cookies.get(this.$store.state.LangCooki) != null) {
                if(this.$cookies.get(this.$store.state.LangCooki) == 'en') {
                    return this.$store.state.lang.en;
                } else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur') {
                    return this.$store.state.lang.ur;
                }
                return this.$store.state.lang.ar;
            } else if(this.$store.state.deflang == 'en') {
                return this.$store.state.lang.en;
            } else if(this.$store.state.deflang == 'ur') {
                return this.$store.state.lang.ur;
            }
            return this.$store.state.lang.ar;
        },
        checkStatuss: function() {
            let t = [{text: this.lang.search_all, value: ''}];
            for(let i = 0; i < this.checkUpStatus.length; i++) {
                t.push({text: this.checkUpStatus[i][`name_${this.lang.langname}`], value: this.checkUpStatus[i][`name_${this.lang.langname}`]})
            }
            return t;
        },
        branchesList: function() {
            let t = [];
            for(let i = 0; i < this.branches.length; i++) {
                t.push({text: this.branches[i][`name_${this.lang.langname}`], value: this.branches[i][`name_${this.lang.langname}`]})
            }
            return t;
        },
        headers: function() {
            let t = [
                {text: '#', align: 'center', filterable: false, value: 'count', sortable: false, class: 'backBlack'},
                {text: this.lang.identified, align: 'center', filterable: false, value: 'id', sortable: false, class: 'backBlack'},
                {text: this.lang.received_date, align: 'center', filterable: false, value: 'received_date', sortable: false, class: 'backBlack'}
            ];
            if(this.$store.state.licenseType.showCheckBranch) {
                t.push({text: this.lang.branch_name, align: 'center', filterable: false, value: 'branch', sortable: false, class: 'backBlack'});
            }
            t.push(
                {text: this.lang.company_name, align: 'center', filterable: false, value: 'company_name', sortable: false, class: 'backBlack'},
                {text: this.lang.owner_name, align: 'center', filterable: false, value: 'owner_name', sortable: false, class: 'backBlack'},
                {text: this.lang.mobile, align: 'center', filterable: false, value: 'mobile', sortable: false, class: 'backBlack'},
                {text: this.lang.owner_mobile_number, align: 'center', filterable: false, value: 'owner_mobile_number', sortable: false, class: 'backBlack'},
                {text: this.lang.device_info, align: 'center', filterable: false, value: 'device_info', sortable: false, class: 'backBlack'},
                {text: this.lang.serial_number, align: 'center', filterable: false, value: 'serial_number', sortable: false, class: 'backBlack'},
                {text: this.lang.po_number, align: 'center', filterable: false, value: 'po_number', sortable: false, class: 'backBlack'},
                {text: this.lang.status, align: 'center', filterable: false, value: 'status', sortable: false, class: 'backBlack'},
                {text: this.lang.action, align: 'center', filterable: false, value: '', sortable: false, class: 'backBlue'}
            );
            return t;
        },
        sdate: function() {
            return (new Date(this.sd.year, this.sd.month - 1, this.sd.day + 1)).toISOString().substring(0, 10);
        },
        edate: function() {
            return (new Date(this.ed.year, this.ed.month - 1, this.ed.day + 1)).toISOString().substring(0, 10);
        },
        yearsList: function() {
            const start_year = this.$store.state.licenseType.startYear;
            let t = [{text: this.lang.year, value: -1}];
            for(let i = 0; i < 100; i++) {
                if(parseInt(start_year) + i <= (new Date()).getFullYear()) {
                    t.push({text: start_year + i, value: start_year + i})
                }
            }
            return t
        },
        daysList: function() {
            let t = [{text: this.lang.day, value: -1}];
            for(let i = 1; i <= 31; i++) {
                t.push({text: i, value: i});
            }
            return t;
        },
        monthsList: function() {
            let t = [{text: this.lang.chose_month, value: -1}];
            for(let i = 1; i <= 12; i++) {
                t.push({text: i, value: i});
            }
            return t;
        },
        tabs: function() {
            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);
        },
    },
    methods: {
        text(key) {
            return this.lang[key] || key;
        },
        collectSearch() {
            return {
                module: 'deviceCheckupList',
                elements: {
                    checkup_number: this.checkup_number,
                    sdate: this.sdate,
                    edate: this.edate,
                    po_number: this.po_number,
                    branch: this.branch,
                    ch_type: 3,
                    branchid: localStorage.getItem('defBranch'),
                    financeYear: localStorage.getItem('financeYear'),
                }
            }
        },
        parseDeviceInfo(item) {
            if(!item) return {};
            if(item.device_info && typeof item.device_info === 'object') {
                return item.device_info;
            }
            if(item.transport && typeof item.transport === 'object') {
                return item.transport;
            }
            if(item.transport) {
                try {
                    return JSON.parse(item.transport);
                } catch (_error) {
                    return {};
                }
            }
            return {};
        },
        deviceDisplay(item) {
            const info = this.parseDeviceInfo(item);
            const parts = [
                info.device_name || info.name || item.brand,
                info.device_model || info.model || item.model
            ].filter(Boolean);
            return parts.length ? parts.join(' / ') : '-';
        },
        deviceSerial(item) {
            const info = this.parseDeviceInfo(item);
            return info.serial_number || info.serial || item.plate_number || item.vin || '-';
        },
        viewCheckup(item) {
            this.$refs.addCheckup.reset();
            this.$refs.addCheckup.$refs.addButton.disabled = false;
            this.$refs.addCheckup.getCheckup(item.id);
        },
        addCheck() {
            this.$refs.addCheckup.reset();
            this.$refs.addCheckup.$refs.addButton.disabled = false;
        },
        getBranchesList() {
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getStaticOptions');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[phrase]', 'BranchesList');
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                this.branches = response.data.results.data
            });
        },
        getStatics() {
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getStaticOptions');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[phrase]', 'checkUpStatuses');
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                this.checkUpStatus = response.data.results.data
            });
        },
        getCheckup() {
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getCurrentCheckup');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]', 0);
            post.append('data[sdate]', this.sdate);
            post.append('data[edate]', this.edate);
            post.append('data[checkup_number]', this.checkup_number);
            post.append('data[branch]', this.branch);
            post.append('data[po_number]', this.po_number);
            post.append('data[status]', this.status);
            post.append('data[mobile]', this.mobile);
            post.append('data[brand]', this.device_name);
            post.append('data[plate_number]', this.serial_number);
            post.append('data[ch_type]', 3);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                this.tablerows = response.data.results.data;
            });
        }
    },
    created() {
        this.getStatics();
        this.getBranchesList();
        this.getCheckup();
    }
}
</script>

<style scoped>
.device-cell {
    min-width: 180px;
    white-space: normal;
}
</style>
